import React from "react";
import { Helmet } from "react-helmet-async";

export default function RefundPolicy() {
  return (
    <main className="max-w-4xl mx-auto px-6 py-16">
      {/* ============================
          SEO
      ============================ */}
      <Helmet>
        <title>Cancellation & Refund Policy | Aerzen Air™</title>
        <meta
          name="description"
          content="Read Aerzen Air™ cancellation and refund policy for pre-bookings, including eligibility, timelines, and non-refundable cases."
        />
        <link
          rel="canonical"
          href="https://www.aerzenair.com/refund"
        />
      </Helmet>

      <h1 className="text-3xl font-bold mb-6">Cancellation & Refund Policy</h1>

      <p className="text-gray-700 mb-4">
        This policy governs cancellations and refunds for pre-bookings made on
        AERZEN AIR™.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Pre-Booking Refunds</h2>
      <p className="text-gray-700 mb-4">
        Customers may request cancellation of pre-bookings before dispatch.
        Refunds, if applicable, will be processed to the original payment method
        within 7–10 working days.
      </p>

      <h2 className="font-semibold text-xl mt-6 mb-2">Non-Refundable Cases</h2>
      <p className="text-gray-700 mb-4">
        Once the product is dispatched or custom production has begun, refunds
        may not be possible.
      </p>

      <p className="text-gray-500 text-sm mt-8">
        For support, contact support@airzenair.com
      </p>
    </main>
  );
}
